/* eslint-disable @typescript-eslint/no-unused-vars */
import { Inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { Settings } from '../models/common.model';
import { CommonService } from './common.service';
import { Router } from '@angular/router';
import { MessagingService } from './messaging.service';
import { RuntimeConfigService } from './runtimeConfig.service';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private commonService: CommonService,
    private _messagingService: MessagingService,
    private router: Router,
    private config: RuntimeConfigService,
    private titleService: Title
  ) {}

  script = document.createElement('script');
  async setUpGoogleScript(): Promise<void> {
    setTimeout(() => {
      // Set Google Api keY DYNAMICALLY
      const head = document.getElementsByTagName('body')[0];
      const apiKey = this.config.googleApiKey;

      if (!document.getElementById('testScriptName')) {
        this.script.type = 'text/javascript';
        this.script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,drawing,geometry,visualization&language=en`;
        this.script.id = 'newTestScriptName';
        this.script.async = true;
        head.appendChild(this.script);
      }
    }, 100);
  }

  api: any;
  projectSettings:any;

  async load(): Promise<void> {
    // const verified = await this.verifyTenantUrl();

    // if (!verified) {
    //   localStorage.clear();
    //   this.router.navigate(['/not-verified']); // or the correct route path
    // } else {
    //   this.router.navigate(['/auth/login']);
    this.setData();
    this.api = `${environment.base_url}settings`;
    await this.getGreatSettings();
    this._messagingService.startMessaging();
    // }
  }

  async getGreatSettings(): Promise<void> {
    const res = await this.http.get<{data: Settings}>(this.api).toPromise();
    if (res?.data) {
      this.commonService.settingsSubject.next(res.data);
      this.projectSettings = res.data;
      this.setData();
    }
  }

  async verifyTenantUrl(): Promise<boolean> {
    try {
      const url = window.location.origin;

      const response: any = await this.http
        .post('https://stagesuperadminapi.prep-base.com/admin/tenant/verifyUrl', { url })
        .toPromise();

      return response?.status === 1 && response?.data === true;
    } catch (error) {
      console.error('Tenant verification failed:', error);
      return false;
    }
  }

  setData(): void {
    localStorage.setItem('webSettings', JSON.stringify(this.projectSettings));

    setTimeout(() => {
      const settings = this.projectSettings;
      if (!settings) return;

      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      const setCSSVariable = (key: string, value: string | null | undefined) => {
        if (value) document.documentElement.style.setProperty(key, value);
      };

      // Set CSS Variables
      setCSSVariable('--c_primary', settings.theme || settings.colorCodes);
      setCSSVariable('--c_secondary', settings.buttonPrimary);
      setCSSVariable('--c_secondary_txt', settings.buttonTextColor);

      // Set Favicon
      this.setElementAttribute('appFavicon', 'href', settings.favIcon);

      // Set Title
      if (settings.appName) {
        this.titleService.setTitle(settings.appName);
      }

      // Set Logos
      this.setElementAttribute('appLogo', 'src', settings.appLogo);
      this.setElementAttribute('webLogo', 'src', settings.webLogo);
    }, 1000);
  }

  private setElementAttribute(id: string, attr: string, value?: string): void {
    if (!value) return;
    const el = this._document.getElementById(id);
    if (el) el.setAttribute(attr, value);
  }

}
